// extracted by mini-css-extract-plugin
export default {"galleryContainer":"GalleryContainer_galleryContainer__9pOZ+","heading":"GalleryContainer_heading__ZTKDF"};